import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-evaluate_ic_star",
  "use": "icon-evaluate_ic_star-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-evaluate_ic_star\"><path d=\"m4.9 2 .2 2.9-2.6-1.1-.5 1.5 2.8.7-1.9 2.1 1.2 1 1.6-2.4 1.6 2.4 1.2-1-1.8-2.1 2.8-.7-.5-1.5-2.7 1.1.2-2.9z\" fill=\"#4bd214\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/evaluate_ic_star.svg
// module id = qP0x
// module chunks = 87